<template>
  <div class="purchaserLogged" v-if="showFlag">
    <ul class="clearfix">
      <li class="pull-left" v-if="isCompanyManager || checkIsWanbangGroup == '0'" @click="shoppingMallUrl(companyConfigUrl,links.onelinkShoppingMallUrl)">
        <transition name="el-fade-in">
        <div class="purchaserLeadStep" v-show="leadSteps.firstStep">
          <p>点击 【企业信息管理】进入企业配置中心可维护企业信息、账户信息及权限信息</p>
          <el-button @click.stop="stepLogged('firstStep','thirdStep')">下一步</el-button>
          <div class="leadArrowDown">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowDown.png" alt="">
          </div>
        </div>
          </transition>
        <div :class="leadSteps.firstStep?'purchaserLi loggedLead':'purchaserLi'"  v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/purchaser_icon01.png" alt="">
          <h4 v-if="checkIsWanbangGroup == '0'">医药商城</h4>
          <h4 v-else>企业信息管理</h4>
          <p></p>
        </div>
      </li>
      <li class="pull-left" v-if="!isCompanyManager && checkIsWanbangGroup != '0'"  @click="goHref('/messageNotification')">
        <div class="purchaserLi" v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/%E9%87%87%E6%96%B9.png" alt="">
          <h4>消息通知</h4>
          <p></p>
        </div>
      </li>
      <li class="pull-left" @click="demandApplyUrl(purchaserMenuList.purchaserApplyUrl,links.demandPurchaseApplyUrl)">
        <div class="purchaserLi" v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/purchaser_icon02.png" alt="" >
          <h4>采购申请</h4>
          <!--<p>采招平台</p>-->
        </div>
      </li>
      <li class="pull-left" @click="jump(ongoingRecruitProjectUrl)">
        <transition name="el-fade-in">
        <div class="purchaserLeadStep" v-show="leadSteps.fourthStep">
          <p>点击 【进行中的项目】直接进入采招平台，查看进行中的项目</p>
          <el-button @click.stop="stepLogged('fourthStep','fifthStep')">下一步</el-button>
          <div class="leadArrowDown">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowDown.png" alt="">
          </div>
        </div>
          </transition>
        <div :class="leadSteps.fourthStep?'purchaserLi loggedLead':'purchaserLi'"  v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/purchaser_icon03.png" alt="" >
          <h4>进行中项目</h4>
          <p>采招平台</p>
        </div>
      </li>
      <li class="pull-left" @click="jumpExt(purchaserMenuList.ongoingOrderUrl)">
        <div class="purchaserLi"  v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/purchaser_icon04.png" alt="" >
          <h4>进行中订单</h4>
          <p>协同平台</p>
        </div>
      </li>
      <li class="pull-left" @click="jumpExt(purchaserMenuList.ongoingReceivingGoodsUrl)">
        <div class="purchaserLi"  v-if="showFlag">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/purchaser_icon05.png" alt="" >
          <h4>进行中收货</h4>
          <p>协同平台</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Cookies from 'js-cookie'

export default {
  props: ['purchaserMenuList','viewMessageUrl','companyConfigUrl','coordinationSystemAuthFlag','ongoingRecruitProjectUrl','links'],
  data () {
    return {
      userInfo:{},
      showFlag:false,
      isCompanyManager:false,
      checkIsWanbangGroup:''
    }
  },
  computed: mapState([
    'KP',
    'leadSteps'
  ]),
  created () {
     if(this.getToken('isLogin') == 100){
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        let userTag = this.userInfo.userTag;
        if(this.getToken('isCompanyManager') == 100){
          this.isCompanyManager  = true;
        }else{
          this.isCompanyManager  = false;
        }
        if(userTag == '20'){
          this.showFlag = true;
        }else{
          this.showFlag = false;
        }
       if(null != Cookies.get('checkIsWanbangGroup')){
          this.checkIsWanbangGroup = Cookies.get('checkIsWanbangGroup');
        }
      }
  },
  mounted () {
    //是否显示引导页
    this.stepLoggedShow();
  },
  methods: {
    goHref(url){
      if(url.indexOf('http') == 0){
        window.location.href = url;
      }else{
        this.$router.push({path:url});
      }
    },
    shoppingMallUrl(url,url2){
      if(this.checkIsWanbangGroup == '0'){
        window.location.href = url2;//医药商城跳转
      }else{
        this.jump(url);
      }
    },
    demandApplyUrl(url,url2){
      if(this.checkIsWanbangGroup == '0'){
        window.location.href = url2;//采购申请为万邦群组的跳转
      }else{
        this.jump(url);
      }
    },
    jump(url){
      if(this.leadSteps.maskStep == false){
        return;
      };
      if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName,createUserId:this.userInfo.createUserId}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
          this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
              dangerouslyUseHTMLString: true,
              customClass:'mobileText',
              center: true,
              showClose:false
            });
        }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
          this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
            cancelButtonClass:'cancelBtn',
            customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else{
        if(url.indexOf('http') == 0){
          window.location.href = url;
        }else{
          this.$router.push({path:url});
        }
      }
       
    },
    jumpExt(url){
      if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName,createUserId:this.userInfo.createUserId}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      // else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
      //   this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
      //       dangerouslyUseHTMLString: true,
      //       customClass:'mobileText',
      //       center: true,
      //       showClose:false
      //     });
      // }else if(this.getToken('checkFlag') == 200){
      // this.$alert('<h4 style="font-size: 18px;line-height: 28px">您的企业信息不完整，无法进入项目。<br>请立即完善企业信息</h4>', '', {
      //   confirmButtonText: '立即完善企业信息',
      //     dangerouslyUseHTMLString: true,
      //     center: true,
      //     showClose:false,
      //     callback: action => {
      //       this.$router.push({path:'/inforPerfection'});
      //     }
      // });
      // }
      else{
        if(this.coordinationSystemAuthFlag == '100'){
          window.location.href=url;
        }else{
          this.$router.push({path:'/supplyChain'});
        }
      }
    },
    stepLoggedShow(){
      Object.assign(this, mapMutations(['modifyLeadStep']));
      if(this.getToken('isLogin') == 100 && this.getToken('isExperience') == 1){
        if(this.userInfo.userTag == '20' && this.getToken('isCompanyManager') == 100 && this.checkIsWanbangGroup != '0'){
          this.stepLogged('maskStep','firstStep');
        }else if(this.userInfo.userTag == '20' && this.getToken('isCompanyManager') == 100 && this.checkIsWanbangGroup == '0'){
          this.stepLogged('maskStep','thirdStep');
        }else if(this.userInfo.userTag == '20' && this.getToken('isCompanyManager') != 100){
          this.stepLogged('maskStep','thirdStep');
        }
      }
    },
    stepLogged(val1,val2){
      this['modifyLeadStep']({
        [val1]: false,
        [val2]:true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchaserLogged/index.vue